<template>
  <div id="divSelectPosWrapper">
    <div v-if="isMfaStep" class="mfa-step">
      <VueButton
        class="mfa-back"
        :iconName="arrowLeftIcon.name"
        :iconSize="{ width: arrowLeftIcon.width, height: arrowLeftIcon.height }"
        iconColor="rgb(235, 56, 50)"
        :ghost="true"
        aria-label="POS seçimine dön"
        @click.prevent="handleMfaBack"
      />

      <template v-if="mfaRole === userTokenRoles.RegisterMFA && !localExpiresAt">
        <VueText sizeLevel="11" weightLevel="3" class="mfa-title" color="grey-40">
          İki Aşamalı Giriş
        </VueText>
        <VueText class="mfa-description">
          Sonu {{ maskedPhone }} ile biten telefon numaranıza bir doğrulama kodu gönderilecektir.
        </VueText>
        <div v-if="mfaError" class="mfa-message mfa-message--error">{{ mfaError }}</div>
        <BrandButton
          class="mfa-submit"
          :size="sizes.xxLarge"
          :contentAlignment="constants.flexAlignment.center"
          :disabled="isFetching"
          @click.prevent="sendMfaCode"
          >GÖNDER</BrandButton
        >
      </template>

      <template v-else>
        <VueText sizeLevel="11" weightLevel="3" class="mfa-title" color="grey-40">
          İki Aşamalı Giriş Doğrulama
        </VueText>
        <VueText class="mfa-description">
          Sonu {{ maskedPhone }} ile biten telefon numaranıza gelen 6 haneli doğrulama kodunu
          giriniz.
        </VueText>

        <div
          v-if="timerLabel"
          class="mfa-timer"
          :class="{ 'mfa-timer--warning': secondsLeft < 60 }"
        >
          Kodun geçerlilik süresi: <strong>{{ timerLabel }}</strong>
        </div>
        <div v-else-if="isExpired" class="mfa-timer mfa-timer--expired">
          Kodun süresi doldu. Lütfen yeni kod isteyin.
        </div>

        <div class="mfa-otp">
          <OtpInput v-model="verificationCode" :has-error="!!mfaError" :autofocus="true" />
        </div>
        <div v-if="mfaError" class="mfa-message mfa-message--error">{{ mfaError }}</div>

        <BrandButton
          v-if="isExpired || isBanned"
          class="mfa-resend"
          :size="sizes.xxLarge"
          :contentAlignment="constants.flexAlignment.center"
          :disabled="isFetching"
          @click.prevent="resendMfaCode"
          >KODU YENİDEN GÖNDER</BrandButton
        >
        <BrandButton
          class="mfa-submit"
          :size="sizes.xxLarge"
          :contentAlignment="constants.flexAlignment.center"
          :disabled="isMfaInputDisabled || isFetching"
          @click.prevent="verifyMfaCode"
          >DOĞRULA</BrandButton
        >
      </template>
    </div>

    <VueForm v-else-if="getPosList && getPosList.length" :bodyPadding="['0', '30']">
      <VueButton
        class="pos-back"
        :iconName="arrowLeftIcon.name"
        :iconSize="{ width: arrowLeftIcon.width, height: arrowLeftIcon.height }"
        iconColor="rgb(235, 56, 50)"
        :ghost="true"
        aria-label="Geri dön"
        @click.prevent="$router.go(-1)"
      />
      <VueText
        sizeLevel="11"
        weightLevel="3"
        :class="isChangePos ? 'header-for-pos' : 'header'"
        color="grey-40"
      >
        Şube Seçiniz</VueText
      >
      <VueListView class="branch-list" dir="column">
        <div class="post-list-button" v-for="item in getPosList" :key="item.id">
          <VueButton
            :size="sizes.xLarge"
            :contentAlignment="constants.flexAlignment.center"
            :isSingleLine="false"
            outlined
            class="single-pos-item"
            :class="{ 'selected-pos': selectedPos.id == item.id }"
            @click.prevent="setPos(item)"
            >{{ item.posName }}</VueButton
          >
        </div>
      </VueListView>

      <div slot="footer" class="button-holder">
        <BrandButton
          class="submit-button"
          :size="sizes.xxLarge"
          :contentAlignment="constants.flexAlignment.center"
          type="submit"
          :disabled="!selectedPos.id || isFetching"
          @click.prevent="submitPos"
          >DEVAM ET</BrandButton
        >
      </div>
    </VueForm>
  </div>
</template>
<script>
import VueListView from '@/components/shared/VueListView/VueListView.vue';
import VueButton from '@/components/shared/VueButton/VueButton.vue';
import BrandButton from '@/components/brand/BrandButton/BrandButton.vue';
import VueForm from '@/components/shared/VueForm/VueForm.vue';
import RoutesAthentication from '@/router/routes/RoutesAthentication.js';
import RoutesLogin from '@/router/routes/authentication/RoutesLogin.js';
import COMPONENT_CONSTANTS from '@/constants/component.constants.js';
import { ICON_VARIABLES } from '@/constants/component.constants.js';
import { FLEX_JUSTIFIES } from '@/constants/flex.constants.js';
import { mapGetters } from 'vuex';
import { Account, User } from '@/services/Api/index';
import StorageHelper from '@/utils/storageHelper';
import VueText from '@/components/shared/VueText/VueText.vue';
import AccountMixin from '@/utils/accountUtils.js';
import { setInsiderObject } from '@/utils/insiderUtils';
import { extractErrorMessage } from '../../../../../utils/errorExtractor';
import { UserTokenRoles } from '@/constants/userTokenRoles.js';
import Mfa from '@/services/Api/mfa';
import OtpInput from '@/components/mfa/OtpInput.vue';
import { startChangePosStaffValidation } from '@/utils/changePosStaffValidation';

export default {
  name: 'SelectPos',
  components: {
    VueButton,
    BrandButton,
    VueForm,
    VueListView,
    VueText,
    OtpInput,
  },
  mixins: [AccountMixin],
  data: () => {
    return {
      submitted: false,
      selectedPos: {},
      isMfaStep: false,
      mfaRole: null,
      verificationCode: '',
      mfaError: '',
      secondsLeft: null,
      timerInterval: null,
      localExpiresAt: null,
      isBanned: false,
      unlockDate: null,
      maskedPhoneValue: null,
      previousToken: null,
      previousPos: null,
      mfaCommitted: false,
    };
  },
  props: {
    isChangePos: {
      type: Boolean,
      default: false,
    },
  },
  mounted() {
    if (!this.getPosList) {
      this.$router.push(RoutesLogin.SelectLoginType.path);
      return;
    }

    this.getPosList.forEach(f => {
      if (f.isCurrentPos) {
        this.selectedPos = f;
      }
    });
  },
  computed: {
    ...mapGetters('auth', ['getPosList']),
    ...mapGetters('app', ['getChangedPosToken']),
    ...mapGetters('auth', { isFetching: 'getLoginFetching' }),
    constants() {
      return {
        flexAlignment: FLEX_JUSTIFIES,
      };
    },
    sizes() {
      return COMPONENT_CONSTANTS.COMPONENT_SIZES;
    },
    routes() {
      return {
        auth: RoutesAthentication,
      };
    },
    getIcon() {
      return ICON_VARIABLES.eye;
    },
    arrowLeftIcon() {
      return ICON_VARIABLES.arrowLeft;
    },
    userTokenRoles() {
      return UserTokenRoles;
    },
    maskedPhone() {
      const raw = this.maskedPhoneValue || (this.selectedPos && this.selectedPos.phoneNumber);
      if (!raw) return '****';
      const last4 = String(raw)
        .replace(/\D/g, '')
        .slice(-4);
      return last4 ? `***${last4}` : '****';
    },
    timerLabel() {
      if (!this.secondsLeft || this.secondsLeft <= 0) return null;
      const minutes = Math.floor(this.secondsLeft / 60)
        .toString()
        .padStart(2, '0');
      const seconds = (this.secondsLeft % 60).toString().padStart(2, '0');
      return `${minutes}:${seconds}`;
    },
    isExpired() {
      return this.localExpiresAt !== null && this.secondsLeft !== null && this.secondsLeft <= 0;
    },
    isMfaInputDisabled() {
      return this.isExpired || this.isBanned;
    },
  },
  beforeDestroy() {
    clearInterval(this.timerInterval);
    new StorageHelper({ id: process.env.VUE_APP_STORAGE_MFA_POS_SWITCH_PENDING }).remove();
    if (this.isMfaStep && !this.mfaCommitted) {
      this.rollbackTempStorage();
    }
  },
  methods: {
    setPos(item) {
      this.selectedPos = item;
    },
    rollbackTempStorage() {
      const tokenHelper = new StorageHelper({ id: process.env.VUE_APP_STORAGE_TOKEN_KEY });
      const posHelper = new StorageHelper({ id: process.env.VUE_APP_STORAGE_CURRENT_POS_KEY });
      if (this.previousToken !== null && this.previousToken !== undefined) {
        tokenHelper.set(this.previousToken);
      }
      if (this.previousPos !== null && this.previousPos !== undefined) {
        posHelper.set(this.previousPos);
      }
      this.previousToken = null;
      this.previousPos = null;
    },
    handleMfaBack() {
      new StorageHelper({ id: process.env.VUE_APP_STORAGE_MFA_POS_SWITCH_PENDING }).remove();
      clearInterval(this.timerInterval);
      this.rollbackTempStorage();
      this.isMfaStep = false;
      this.verificationCode = '';
      this.mfaError = '';
      this.secondsLeft = null;
      this.localExpiresAt = null;
      this.isBanned = false;
      this.unlockDate = null;
    },
    startMfaTimer(expireDate) {
      if (!expireDate) return;
      clearInterval(this.timerInterval);
      const expireTime = new Date(expireDate).getTime();
      const updateTimer = () => {
        this.secondsLeft = Math.max(0, Math.floor((expireTime - Date.now()) / 1000));
      };
      updateTimer();
      this.timerInterval = setInterval(() => {
        updateTimer();
        if (this.secondsLeft === 0) clearInterval(this.timerInterval);
      }, 1000);
    },
    async sendMfaCode() {
      try {
        this.$store.dispatch('auth/setLoginFetching', true);
        const res = await Mfa.postSendCode();
        const Data = res && res.data ? res.data.Data : null;
        if (!Data) return;
        if (Data.isBanned) {
          this.isBanned = true;
          this.mfaError =
            Data.message || 'Çok fazla kod istediniz. Lütfen daha sonra tekrar deneyin.';
          return;
        }
        this.maskedPhoneValue = Data.maskedPhone || Data.phoneNumber || this.maskedPhoneValue;
        this.localExpiresAt = Data.expireDate;
        this.startMfaTimer(Data.expireDate);
        this.mfaError = '';
      } catch (error) {
        this.mfaError = extractErrorMessage(error) || 'Kod gönderilemedi. Lütfen tekrar deneyin.';
      } finally {
        this.$store.dispatch('auth/setLoginFetching', false);
      }
    },
    async openMfaStep(tokenRole) {
      this.mfaRole = tokenRole;
      this.isMfaStep = true;
      this.verificationCode = '';
      this.mfaError = '';
      new StorageHelper({ id: process.env.VUE_APP_STORAGE_MFA_POS_SWITCH_PENDING }).set(true);
      if (tokenRole === UserTokenRoles.VerifyMFA) {
        await this.sendMfaCode();
      }
    },
    async resendMfaCode() {
      try {
        this.$store.dispatch('auth/setLoginFetching', true);
        const res = await Mfa.postResendCode();
        const Data = res && res.data ? res.data.Data : null;
        if (!Data) return;
        if (Data.isBanned) {
          this.isBanned = true;
          this.mfaError =
            Data.message || 'Çok fazla deneme yaptınız. Lütfen daha sonra tekrar deneyin.';
          return;
        }
        this.isBanned = false;
        this.verificationCode = '';
        this.mfaError = '';
        this.localExpiresAt = Data.expireDate;
        this.startMfaTimer(Data.expireDate);
      } catch (error) {
        this.mfaError = extractErrorMessage(error) || 'Kod gönderilemedi. Lütfen tekrar deneyin.';
      } finally {
        this.$store.dispatch('auth/setLoginFetching', false);
      }
    },
    async verifyMfaCode() {
      if (this.verificationCode.length !== 6) {
        this.mfaError = 'Lütfen 6 haneli kodu giriniz.';
        return;
      }
      try {
        this.$store.dispatch('auth/setLoginFetching', true);
        const res = await Mfa.postVerifyCode(this.verificationCode);
        const Data = res && res.data ? res.data.Data : null;
        if (!Data) return;
        if (Data.isBanned || Data.isBlocked) {
          this.isBanned = true;
          this.unlockDate = Data.unlockDate;
          this.mfaError = Data.message || 'Çok fazla deneme yaptınız.';
          return;
        }
        if (!Data.success) {
          this.verificationCode = '';
          this.mfaError =
            Data.remainingAttempts > 0
              ? `${Data.message} ${Data.remainingAttempts} deneme hakkınız kaldı.`
              : Data.message;
          return;
        }
        if (
          Data.tokenRole === UserTokenRoles.VerifyMFA ||
          Data.tokenRole === UserTokenRoles.RegisterMFA
        ) {
          this.mfaError = 'Doğrulama tamamlanamadı. Lütfen tekrar deneyin.';
          return;
        }
        await this.completeMfaLogin(Data);
      } catch (error) {
        this.mfaError = extractErrorMessage(error) || 'Doğrulama başarısız. Lütfen tekrar deneyin.';
      } finally {
        this.$store.dispatch('auth/setLoginFetching', false);
      }
    },
    async completeMfaLogin(Data) {
      new StorageHelper({ id: process.env.VUE_APP_STORAGE_MFA_POS_SWITCH_PENDING }).remove();

      const response = { ...Data, pos: [this.selectedPos] };
      const { token, user, refreshToken, pos, staffValidation } = response;

      await this.$store.dispatch('auth/setAuthData', response);

      if (token) {
        new StorageHelper({ id: process.env.VUE_APP_STORAGE_TOKEN_KEY }).set(token);
      }
      if (user) {
        new StorageHelper({ id: process.env.VUE_APP_STORAGE_CURRENT_USER_KEY }).set(user);
      }
      if (refreshToken && refreshToken.token) {
        new StorageHelper({ id: process.env.VUE_APP_STORAGE_REFRESH_TOKEN_KEY }).set(
          refreshToken.token,
        );
      }
      if (pos && pos[0]) {
        new StorageHelper({ id: process.env.VUE_APP_STORAGE_CURRENT_POS_KEY }).set(pos[0]);
        if (!this.isChangePos) {
          this.accountLogin(pos[0].posChannel, staffValidation, user);
        }
      }

      this.mfaCommitted = true;
      this.previousToken = null;
      this.previousPos = null;

      if (this.isChangePos && !staffValidation) {
        await this.handleChangePosStaffValidation(pos[0].posChannel);
      } else {
        await this.updateUserDetailsAfterPosChange();
        this.$emit('closePopUp', staffValidation);
      }
    },
    async handleChangePosStaffValidation(posChannel) {
      await startChangePosStaffValidation(posChannel, () => {
        this.$emit('closePopUp', false);
      });
    },
    async updateUserDetailsAfterPosChange() {
      try {
        const res = await User.getUserDetail();
        if (res && res.data.Data && res.data.Data.userDetail) {
          const userDetails = res.data.Data.userDetail;
          const cookieSettings = res.data.Data.cookieSettings;

          new StorageHelper({
            id: process.env.VUE_APP_STORAGE_CURRENT_USER_DETAIL,
          }).set(userDetails);
          new StorageHelper({
            id: process.env.VUE_APP_STORAGE_CURRENT_USER_COOKIE_SETTINGS,
          }).set(cookieSettings);

          await this.$store.dispatch('auth/setUserDetails', userDetails);
          await this.$store.dispatch('app/setCookieSettings', cookieSettings);

          setInsiderObject(userDetails);
        }
      } catch (error) {
        console.error('Error updating user details after POS change:', error);
      }
    },
    async submitPos() {
      if (!this.selectedPos.id) {
        return;
      }

      const tokenHelper = new StorageHelper({ id: process.env.VUE_APP_STORAGE_TOKEN_KEY });
      const posHelper = new StorageHelper({ id: process.env.VUE_APP_STORAGE_CURRENT_POS_KEY });
      this.previousToken = tokenHelper.get();
      this.previousPos = posHelper.get();
      this.mfaCommitted = false;

      if (this.isChangePos) {
        tokenHelper.set(this.getChangedPosToken);
      }

      try {
        this.$store.dispatch('auth/setLoginFetching', true);

        const selectedPosRes = await Account.selectedPos({ posId: this.selectedPos.id });

        const { Data } = selectedPosRes ? selectedPosRes.data : { Data: null };

        if (!Data) {
          this.rollbackTempStorage();
          return;
        }

        if (
          Data.tokenRole === UserTokenRoles.VerifyMFA ||
          Data.tokenRole === UserTokenRoles.RegisterMFA
        ) {
          if (Data.token) {
            new StorageHelper({ id: process.env.VUE_APP_STORAGE_TOKEN_KEY }).set(Data.token);
          }
          new StorageHelper({ id: process.env.VUE_APP_STORAGE_CURRENT_POS_KEY }).set(
            this.selectedPos,
          );

          const phone = (Data.user && Data.user.phoneNumber) || '';

          if (this.isChangePos) {
            this.maskedPhoneValue = phone;
            await this.openMfaStep(Data.tokenRole);
          } else {
            new StorageHelper({ id: process.env.VUE_APP_STORAGE_PRE_MFA_TOKEN }).set(
              this.previousToken,
            );

            const last4 = String(phone)
              .replace(/\D/g, '')
              .slice(-4);
            this.$router.push({
              path: RoutesLogin.LoginMfaVerification.path,
              query: {
                mfaRole: Data.tokenRole,
                maskedPhone: last4,
                mfaOrigin: RoutesLogin.SelectPos.name,
              },
            });
          }
          return;
        }

        this.previousToken = null;
        this.previousPos = null;

        const response = { ...Data, pos: [this.selectedPos] };

        const { token, user, refreshToken, pos, staffValidation } = response;

        await this.$store.dispatch('auth/setAuthData', response);

        if (token) {
          new StorageHelper({ id: process.env.VUE_APP_STORAGE_TOKEN_KEY }).set(token);
        }
        if (user) {
          new StorageHelper({ id: process.env.VUE_APP_STORAGE_CURRENT_USER_KEY }).set(user);
        }
        if (refreshToken) {
          new StorageHelper({ id: process.env.VUE_APP_STORAGE_REFRESH_TOKEN_KEY }).set(
            refreshToken.token,
          );
        }
        if (pos) {
          new StorageHelper({ id: process.env.VUE_APP_STORAGE_CURRENT_POS_KEY }).set(pos[0]);
          if (!this.isChangePos) {
            this.accountLogin(pos[0].posChannel, staffValidation, user);
          }
        }

        if (this.isChangePos && !staffValidation) {
          await this.handleChangePosStaffValidation(pos[0].posChannel);
        } else {
          await this.updateUserDetailsAfterPosChange();
          this.$emit('closePopUp', staffValidation);
        }
      } catch (error) {
        this.rollbackTempStorage();
        this.$store.dispatch('auth/setLoginError', error);
        const errModalConfig = {
          isModalOpened: true,
          modalText: extractErrorMessage(error),
        };
        this.$store.dispatch('app/setErrorModalConfig', errModalConfig);
      } finally {
        this.$store.dispatch('auth/setLoginFetching', false);
      }
    },
  },
};
</script>
<style scoped lang="scss">
.header {
  padding-top: palette-space-level('60');
  padding-bottom: palette-space-level('10');
}
.header-for-pos {
  padding-top: palette-space-level('20');
  padding-bottom: palette-space-level('10');
}

.post-list-button {
  padding-top: palette-space-level('20');
}

.button-holder {
  padding-top: palette-space-level('40');
  .submit-button {
    border-radius: palette-radius-level('2');
  }
}

.selected-pos {
  background-color: palette-color-level('green', 30) !important;
  color: palette-color-level('white', 100) !important;
}

.single-pos-item {
  overflow: hidden;
  text-overflow: ellipsis !important;
}
.branch-list {
  height: 450px;
  padding-right: palette-space-level('10');
  box-shadow: 0 2px 0 0 rgba(0, 0, 0, 0.05);

  &::-webkit-scrollbar {
    width: 8px;
  }
  &::-webkit-scrollbar-track {
    width: 8px;
    border-radius: 5.5px;
    background-color: palette-color('grey-10');
  }
  &::-webkit-scrollbar-thumb {
    width: 8px;
    border-radius: 5.5px;
    background-color: palette-color('grey-40');
  }
}

.pos-back {
  display: block;
  width: auto;
  margin: 0 0 12px;
}

.mfa-step {
  box-sizing: border-box;
  padding: 20px 30px 16px;
  text-align: center;
}

.mfa-back {
  display: block;
  width: auto;
  margin: 0 0 12px;
}

.mfa-title {
  display: block;
  margin-bottom: 12px;
}

.mfa-description {
  display: block;
  line-height: 1.5;
  margin-bottom: 20px;
}

.mfa-timer {
  font-size: 13px;
  color: rgba(0, 0, 0, 0.5);
  margin-bottom: 16px;

  &--warning {
    color: #e65100;
  }

  &--expired {
    color: #d32f2f;
  }
}

.mfa-otp {
  display: flex;
  justify-content: center;
  margin-bottom: 12px;
}

.mfa-message {
  font-size: 13px;
  margin-bottom: 16px;

  &--error {
    color: #d32f2f;
  }
}

.mfa-resend,
.mfa-submit {
  width: 100%;
  margin-bottom: 12px;

  .submit-button {
    border-radius: palette-radius-level('2');
  }
}
</style>
